import style from './index.module.scss';

export const ContentLayout = ({ children }: any) => {
  return <div className={style.content}>{children}</div>;
};
